export default __webpack_public_path__ + "static/media/Cloudxier-ARIF-Profile-Developer.2bb7423a.png";